import { render, staticRenderFns } from "./Imagenes.vue?vue&type=template&id=f4f8426c&scoped=true"
import script from "./Imagenes.vue?vue&type=script&lang=js"
export * from "./Imagenes.vue?vue&type=script&lang=js"
import style0 from "./Imagenes.vue?vue&type=style&index=0&id=f4f8426c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f8426c",
  null
  
)

export default component.exports